import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog can be accessed throughout your Next.js app by using the `}<inlineCode parentName="p">{`usePostHog`}</inlineCode>{` hook.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`'use client'
import { usePostHog } from '@posthog/react'

export default function Home() {
  const posthog = usePostHog()

  return (
    <div>
      <button onClick={() => posthog.capture('test_event')}>
        Click me for an event
      </button>
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      